import { UseQueryOptions } from 'react-query';
import { useGetAlarmQuery } from './index';

export const useGetAlarm = (id: string | undefined, options?: UseQueryOptions) => {
  const { data: item, ...result } = useGetAlarmQuery(id, options);

  return {
    item,
    ...result,
  };
};
